import * as React from "react";
import dayjs from "dayjs";

import { Box, Grid } from "@mui/material";

import CustomInput from "../../../../helper-components/input/CustomInput";
import CustomButton from "../../../../helper-components/input/CustomButton";

import { validateRow } from "../../../../helper-functions/validation/objectValidation";
import { addFormToObj, setInsertObjectState, setValue } from "../../../../helper-functions/shared/miscUtils";
import { IS_USER_VALID, USER_VALIDATION } from "../../../../helper-functions/validation/userValidation";

import { getLanguage } from "../../../../config/language/language";
import { ROLE_TYPES, USER_REQUEST_OBJECT, USER_STATUS_TYPES } from "../../../../config/constants/Constants";

/**
 * A form to update a user.
 */
export default function UserEditForm(props) {
    // Because modals don't re-render if the props' state changes, use a callback.
    const { callback, row: existingRow = {} } = props;

    const object = USER_REQUEST_OBJECT;
    const validation = USER_VALIDATION;
    const isValid = IS_USER_VALID;

    const [row, setRow] = React.useState(addFormToObj(JSON.parse(JSON.stringify(object))));

    const roleOptions = ROLE_TYPES.map((r) => r.role);

    // Initialize the temporary row object with existing values.
    React.useEffect(() => {
        const newRow = {
            ...row,
            ...existingRow,

            // Convert to dayjs format if datetime exists.
            created_on: existingRow.created_on ? dayjs(existingRow.created_on) : null,
            last_login: existingRow.last_login ? dayjs(existingRow.last_login) : null,

            _role: existingRow.role?.role,
            role_id: existingRow.role?.id,

            form: {
                ...row.form,
                ...existingRow.form,
                saved: false // Required to allow editing input fields.
            }
        };

        setInsertObjectState(setRow, newRow);
    }, []);

    /**
     * Executed when typing something into an input field.
     */
    const onChange = (obj, key, value) => {
        const newUser = JSON.parse(JSON.stringify(row));
        setValue(newUser, key, value);

        if (key === "_role") {
            const role = ROLE_TYPES.find((r) => r.role === value);
            setValue(newUser, "role_id", role?.id);
        }

        validateRow(obj, validation, newUser);
        setInsertObjectState(setRow, newUser);
    };

    const handleClick = () => {
        if (!isValid(row)) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_FORM_INVALID, color: "error" });
            return;
        }

        const options = { row };
        callback(true, options);
    };

    return (
        <Box className="box">
            <Grid container spacing={1}>
                <Grid item xs={6} sm={6}>
                    <CustomInput name="username" row={row} onChange={onChange} label="Username" />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <CustomInput name="email" row={row} onChange={onChange} label="Email" />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <CustomInput name="_role" row={row} onChange={onChange} label="Role" select={roleOptions} />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <CustomInput name="status" row={row} onChange={onChange} label="Status" select={USER_STATUS_TYPES} />
                </Grid>
            </Grid>

            <CustomButton {...props} title={"Update user"} onClick={handleClick} className="button" fullWidth />
        </Box>
    );
}
